export const getBlockProps = (id, slateProps, customBlock) => {
    const { compiledSlate, updateBlockById, updateExtraContext, extraContext: { blocks: blocksExtraContext }, } = slateProps;
    const block = customBlock || compiledSlate.blocks[id];
    const extraContext = blocksExtraContext[id] || {};
    return {
        block,
        id,
        extraContext,
        updateBlock: input => updateBlockById(id, input),
        updateOutput: output => updateBlockById(id, { output }),
        updateProps: props => updateBlockById(id, {
            props,
        }),
        upsertProps: newProps => {
            updateBlockById(id, {
                props: Object.assign(Object.assign({}, block.props), newProps),
            });
        },
        upsertProp: (key, value) => {
            updateBlockById(id, {
                props: Object.assign(Object.assign({}, block.props), { [key]: value }),
            });
        },
        updateExtraContext: value => {
            updateExtraContext({
                blocks: Object.assign(Object.assign({}, blocksExtraContext), { [id]: Object.assign(Object.assign({}, extraContext), value) }),
            });
        },
    };
};
export const getBlockConfigs = (options) => {
    const { context, block: { extraProps = {} }, registeredBlock: { config }, props, compiledProps, } = options;
    const { getContextAwareConfig } = config;
    return Object.assign(Object.assign(Object.assign({}, config), (getContextAwareConfig
        ? getContextAwareConfig({ context, props, compiledProps })
        : {})), extraProps);
};
//# sourceMappingURL=block.utils.js.map